'use client';

import { EventsPage } from './EventsPage';

/**
 * `/map` route for UWR — renders the unified EventsPage in map mode
 * so the global map experience lives alongside the list view.
 */
export function GlobalMapPage() {
  return <EventsPage initialView="map" />;
}
